import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media ${device.mobileMax} {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    background: ${colors.white};
  }
`

export const MessageContainer = styled.div`
  padding: 24px;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media ${device.mobileMax} {
    margin-top: 72px;
    flex-direction: column;
    align-items: center;
  }
`

export const Title = styled.h4`
  margin: 0 0 16px 0;
  width: 100%;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.mainText};
  text-align: center;
`

export const Text = styled.span`
  margin-bottom: 8px;
  font-size: 14px;
  color: ${colors.mainText};

  &:last-child {
    margin-bottom: 0;
  }
`

export const ButtonsContainer = styled.div`
  padding: 24px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9.5px 40px;
  height: 40px;
  font-size: 14px;
  border-radius: 27px;
  color: ${colors.white};
  background-color: ${colors.green};
  border: 1px solid ${colors.green};
`
